import { render, staticRenderFns } from "./IssueStatusTableCard.vue?vue&type=template&id=2a99d9f2&"
import script from "./IssueStatusTableCard.vue?vue&type=script&lang=js&"
export * from "./IssueStatusTableCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports